import { Button, Input, Separator } from '@/components/atoms';
import { FormField, ContinueWithGoogle } from '@/components/molecules';
import { useLogin, type LoginPayload } from '@/api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { loginSchema } from '@/validation-schema';
import { getUserIdFromAuthToken } from '@/lib/auth';
import { routes } from '@/lib/constants';
import { Link, useNavigate } from 'react-router';

export const LoginForm = () => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(loginSchema),
    mode: 'onChange',
  });

  const { mutate: loginUser, isPending } = useLogin((data) => {
    if (data.data?.hasBusinessSetup) {
      navigate(routes.root, { replace: true });
      return;
    }

    const phoneVerified = data.data?.isPhoneVerified === true;
    navigate(routes.signUp, {
      replace: true,
      state: {
        step: phoneVerified ? 3 : 2,
        userId: getUserIdFromAuthToken(),
      },
    });
  });

  const signIn = (userData: LoginPayload) => {
    loginUser(userData);
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(signIn)}
        className="grid grid-cols-2 gap-6 px-4 md:px-6 lg:px-8"
      >
        <FormField
          label="Email"
          className="col-span-2"
          error={errors.email?.message}
        >
          <Input
            placeholder="example@gosellyt.com"
            type="email"
            {...register('email')}
          />
        </FormField>
        <FormField
          label="Password"
          className="col-span-2"
          error={errors.password?.message}
        >
          <Input
            type="password"
            placeholder="minimum 8 characters"
            {...register('password')}
          />
        </FormField>
        <Link
          to={routes.forgotPassword}
          className="text-primary text-xs text-right col-span-2 -mt-4"
        >
          Forgot password?
        </Link>
        <Button
          className="col-span-2"
          label="Sign in"
          size="lg"
          type="submit"
          isLoading={isPending}
          disabled={!isValid}
        />
      </form>
      <div className="grid grid-cols-2 gap-6 px-4 md:px-6 lg:px-8">
        <div className="flex items-center gap-4 relative col-span-2 px-4 md:px-6 lg:px-8">
          <Separator />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="py-1 px-6 text-center bg-white">or</span>
          </div>
        </div>
        <ContinueWithGoogle />
      </div>
    </>
  );
};
